var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "properties-field-content" }, [
    _c("div", { staticClass: "section-field input-field pb-0 border-0" }, [
      _c(
        "div",
        { staticClass: "configuration-section" },
        [
          _c("h4", { staticClass: "configuration-section-title" }, [
            _vm._v("General")
          ]),
          _vm._v(" "),
          _c(
            "b-form",
            { class: { "error-input": _vm.$v.dataSetup.title.$error } },
            [
              _c("label", [_vm._v(" Title ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: {
                  "error-required": _vm.$v.dataSetup.title.$error,
                  placeholder: "Type title for this component"
                },
                model: {
                  value: _vm.dataSetup.title,
                  callback: function($$v) {
                    _vm.$set(_vm.dataSetup, "title", $$v)
                  },
                  expression: "dataSetup.title"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "section-field input-field" }, [
      _c(
        "div",
        {
          staticClass: "configuration-section",
          class: { "error-input": _vm.$v.dataSetup.selected_view.$error }
        },
        [
          _c("h4", { staticClass: "configuration-section-title" }, [
            _vm._v("Primary View")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "title-configuration-section-desc" }, [
            _vm._v(
              "\n        Choose an action to be used for this action and a connection to a third party.\n      "
            )
          ]),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "title-configuration-section-desc-gray mb-1" },
            [_vm._v("\n        Desktop\n      ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "div-view mb-3" },
            _vm._l(_vm.list_view, function(view) {
              return _c(
                "div",
                {
                  key: view.id,
                  staticClass: "view",
                  class: {
                    active:
                      _vm.dataSetup.selected_view &&
                      _vm.dataSetup.selected_view.id === view.id,
                    disabled: !view.hasSetup
                  },
                  on: {
                    click: function($event) {
                      _vm.selectView(view, true)
                    }
                  }
                },
                [
                  _vm.dataSetup.selected_view &&
                  _vm.dataSetup.selected_view.id === view.id
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/new-form-ui/icon-active/" +
                            view.icon +
                            ".svg")
                        }
                      })
                    : _c("img", {
                        attrs: {
                          src: require("@/assets/new-form-ui/icon/" +
                            view.icon +
                            ".svg")
                        }
                      }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(view.name))])
                ]
              )
            })
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "title-configuration-section-desc-gray mb-1" },
            [_vm._v("\n        Mobile Apps\n      ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "div-view" },
            _vm._l(_vm.list_view_small, function(view) {
              return _c(
                "div",
                {
                  key: view.id,
                  staticClass: "view",
                  class: {
                    active:
                      _vm.dataSetup.selected_view_small &&
                      _vm.dataSetup.selected_view_small.id === view.id,
                    disabled: !view.hasSetup
                  },
                  on: {
                    click: function($event) {
                      _vm.selectView(view, false)
                    }
                  }
                },
                [
                  _vm.dataSetup.selected_view_small &&
                  _vm.dataSetup.selected_view_small.id === view.id
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/new-form-ui/icon-active/" +
                            view.icon +
                            ".svg")
                        }
                      })
                    : _c("img", {
                        attrs: {
                          src: require("@/assets/new-form-ui/icon/" +
                            view.icon +
                            ".svg")
                        }
                      }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(view.name))])
                ]
              )
            })
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79fe6e6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79fe6e6e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/detail/app-tabs/forms/jExpManagerForm.vue
// module id = null
// module chunks = 